// extracted by css-extract-rspack-plugin
export default {"segmentedControl":"segmented-control-module__segmentedControl__Lzsee","active":"segmented-control-module__active__Ed6rO"};